import { render, staticRenderFns } from "./AddWorkSamplesToContractorByManagement.vue?vue&type=template&id=0d0d42a2"
import script from "./AddWorkSamplesToContractorByManagement.vue?vue&type=script&lang=ts"
export * from "./AddWorkSamplesToContractorByManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0d42a2')) {
      api.createRecord('0d0d42a2', component.options)
    } else {
      api.reload('0d0d42a2', component.options)
    }
    module.hot.accept("./AddWorkSamplesToContractorByManagement.vue?vue&type=template&id=0d0d42a2", function () {
      api.rerender('0d0d42a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddWorkSamplesToContractorByManagement.vue"
export default component.exports